import React, { useEffect, useState, useCallback } from 'react'
import { Input, Select } from '../../../components/ModalInputs'
import Modal from 'react-responsive-modal'
import { useFormik } from 'formik'
import Button from '../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { addStudent, getSpeciality } from '../../../actions/profotbor'
import { render } from '@testing-library/react'
import moment from 'moment'
import Table from '../../../components/Table'
import styles from '../styles.module.scss'
import { createNotification } from '../../../components/Notifications/Notifications'
import Confirmation from '../../../components/Confirmation/Confirmation'


export default function ModalComponent ({data}) {
  
  const dispatch = useDispatch()
  const { students, speciality: specs, current} = useSelector(state => state.profotbor)

  const [modal, setModal] = useState(false)
  const [speciality, setSpeciality] = useState('')
  const [mid, setMid] = useState(null)
  const [confirmClose, setConfirmClose] = useState(false)

  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmClose = useCallback(() => { setModal(false); setConfirmClose(false) }, [])
  const rejectConfirmClose = useCallback(() => setConfirmClose(false), [])
  
  useEffect(() => {
    !specs.length && dispatch(getSpeciality())
  }, [])

  useEffect(() => {
    if (!modal) return;
    setSpeciality('')
    setMid(null)
  }, [modal])
  
  const submitHandler = () => {
    if (!mid || !speciality) return createNotification('error', 'Выберите ученика и специальность');
    const payload = {data: [{mid, speciality}]}
    dispatch(addStudent(current.id, payload))
  }

  const renderRow = (student) => (
    <tr className={mid === student.pmid && styles.selectedRow} onClick={() => setMid(student.pmid)}>
      <td>{student.fio}</td>
      <td>{moment(student.birthday).format('DD.MM.YYYY')}</td>
      <td>{student.groupname}</td>
    </tr>
  )

  return (
      <>
        <Modal
          open={modal}
          onClose={handleClose}
          closeOnEsc={true}
          closeOnOverlayClick={true}
          showCloseIcon={false}
          classNames={{modal: styles.peoplesModal}}
          animationDuration={1}
        >
          <h1>Участники</h1>

          <Select
            label='Специальность'
            name='vuz'
            value={speciality}
            onChange={e => setSpeciality(e.target.value)}
          >
            <option value=''>Не выбрано</option>
            {specs.map(spec => <option key={spec.id} value={spec.id}>{spec.name}</option>)}
          </Select>

          <Table>
            <thead>
              <tr>
                <th>ФИО</th>
                <th>Дата рождения</th>
                <th>Класс</th>
              </tr>
            </thead>
            <tbody>
              {students.map(renderRow)}
            </tbody>
          </Table>

          <div>
            <Button onClick={submitHandler}>Добавить</Button>
            <Button onClick={() => setModal(false)}>Отмена</Button>
          </div>

          {confirmClose && (
            <Confirmation
              title="Закрыть без сохранения изменений?"
              acceptConfirmation={acceptConfirmClose}
              rejectConfirmation={rejectConfirmClose}
            />
          )}
        </Modal>
        <Button onClick={() => setModal(true)}>Добавить участника</Button>
      </>
  )
}
